import React from 'react';
import { View } from 'react-native';

import { Text } from 'react-native-web';
import SwitcherPanel from './SwitcherPanel';
import {
  available_languages_list,
  default_str,
  make_default_str,
  paykey_engine,
  rebit_engine,
} from '../../../utils/DictionaryManagementUtils';
import LinkTextButton from './LinkTextButton';
import { LocStr } from '../../../utils/Utils';
import StateAtLaunchPanelComponent from './StateAtLaunchPanelComponent';

//= ========================================================================

const AvailableLanguagesList = ({
  ArgumentList,
  onConfigChanged,
  keyboard_language,
  language,
}) => {
  const myStyle = {
    container: {
      marginBottom: 20,
    },
    default_str_style: {
      width: 150,
      fontSize: 14,
      fontWeight: 'bold',
      color: '#051c37',
    },
  };
  const engineType = keyboard_language.is_rebit_engine ? rebit_engine : paykey_engine;
  const onValueChanged = (key, value) => {
    key.enabled_upon_keyboard_launch = value;
    onConfigChanged();
  };

  return (
    <StateAtLaunchPanelComponent
      style={{ marginTop: 20, zIndex: 2 }}
      language={language}
      onConfigChanged={onConfigChanged}
      keyboard_language={keyboard_language}
    >
      {Object.values(ArgumentList).map((language_str) => (
        <View style={myStyle.container}>
          <SwitcherPanel
            alwaysOn={keyboard_language.default_languages[engineType] === language_str}
            text={available_languages_list[language_str]}
            value={keyboard_language.available_languages[engineType][language_str].enabled_upon_keyboard_launch}
            onValueChanged={(value) => {
              if (keyboard_language.default_languages[engineType] !== language_str) {
                onValueChanged(keyboard_language.available_languages[engineType][language_str], value);
              }
            }}
            marginBottom={-5}
            marginTop={5}
          />
          {keyboard_language.default_languages[engineType] === language_str
                    && <Text style={myStyle.default_str_style}>{default_str}</Text>}

          {keyboard_language.available_languages[engineType][language_str].can_be_default
          && (keyboard_language.default_languages[engineType] !== language_str)
            && (
              <LinkTextButton
                left
                width={90}
                onPress={() => {
                  keyboard_language.default_languages[engineType] = language_str;
                  onValueChanged(keyboard_language.available_languages[engineType][language_str], true);
                  onConfigChanged();
                }}
              >
                {LocStr(make_default_str, language)}
              </LinkTextButton>
            )}
        </View>
      ))}
    </StateAtLaunchPanelComponent>
  );
};
export default AvailableLanguagesList;
